export enum messagePath {
  DEFAULT_MESSAGE = '',
  SENDING_MESSAGE = '/sending-message',
  TEMPLATES_MESSAGE = '/templates-message',
  MESSAGE_SYSTEM = '/message-system',
  LICENSE_MESSAGE = '/license-message'
}
